<template>
    <div class="modal is-active">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("prepare-photo.title") }}
                </p>
                <button class="delete" @click="close"></button>
            </header>
            <section class="modal-card-body">
                <UserSelect v-model="selectedUser" />
                <div class="field">
                    <label class="label">{{
                        $t("prepare-photo.photo-title")
                    }}</label>
                    <div class="control">
                        <input
                            v-model="title"
                            type="text"
                            class="input"
                            :class="{ 'is-danger': wrongTitle }"
                        />
                    </div>
                    <p v-if="wrongTitle" class="help is-danger">
                        {{ $t("prepare-photo.wrong-title") }}
                    </p>
                </div>
                <div class="field">
                    <div class="camera-container">
                        <div v-show="!photoDone">
                            <div ref="videoContainer"></div>
                        </div>
                        <div v-if="photoDone" class="photo-preview">
                            <img :src="photo.contentUrl" />
                        </div>
                        <div class="field is-grouped is-grouped-centered">
                            <button
                                v-if="!photoDone && isUserSelected"
                                class="button"
                                @click="takePhoto"
                            >
                                <Icon name="fa-camera" />
                            </button>
                            <button
                                v-if="photoDone"
                                class="button"
                                @click="undo"
                            >
                                <Icon name="fa-undo-alt" />
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot is-justify-content-flex-end">
                <button class="button" @click="send" :disabled="!photoDone">
                    <Icon
                        name="fa-paper-plane"
                        helperClass="has-text-primary"
                    />
                    <span>{{ $t("prepare-photo.send") }}</span>
                </button>
            </footer>
            <canvas ref="canvas" style="display: none"></canvas>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import { v4 as uuidv4 } from "uuid";
import { RepositoryFactory } from "@/services/api";

import UserSelect from "../UserSelect";

export default {
    name: "prepare-photo",
    components: {
        UserSelect,
    },
    props: {
        participants: { type: Array },
    },
    data() {
        return {
            title: "",
            selectedUser: null,
            wrongTitle: false,

            photo: null,
        };
    },
    computed: {
        ...mapGetters("conference", ["getConferenceId"]),
        ...mapGetters("oidcStore", ["oidcUser"]),
        name() {
            return this.selectedUser === null ? "" : this.selectedUser.name;
        },
        isUserSelected() {
            return this.selectedUser !== null;
        },
        photoDone() {
            return this.photo !== null;
        },
    },
    watch: {
        selectedUser(selectedUser) {
            // On change user, select camera
            this.loadParticipant(selectedUser);
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
        loadParticipant(selectedUser) {
            let participant = this.participants.find(
                (p) => p.identity === selectedUser.id
            );

            this.$refs.videoContainer.children.forEach(function (c) {
                this.$refs.videoContainer.removeChild(c);
            });

            participant.videoTracks.forEach((publication) => {
                if (publication.isSubscribed) {
                    const track = publication.track;
                    this.$refs.videoContainer.appendChild(track.attach());
                }
            });
        },
        takePhoto() {
            let canvas = this.$refs.canvas;
            let video = this.$refs.videoContainer.children[0];
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            canvas.getContext("2d").drawImage(video, 0, 0);

            let dataUrl = canvas.toDataURL("image/png");
            this.photo = {
                contentUrl: dataUrl,
                content: dataUrl.replace("data:image/png;base64,", ""),
            };
        },
        undo() {
            this.photo = null;
        },
        async send() {
            if (this.title === "") {
                this.wrongTitle = true;
                return;
            }
            this.wrongTitle = false;

            this.photo.actionId = uuidv4();
            this.photo.filename = `${this.title}.png`;
            this.photo.roomId = this.getConferenceId;
            this.photo.userId = this.oidcUser.sub;
            this.photo.participantId = this.selectedUser.id;

            let response = await RepositoryFactory.files.postPhoto(this.photo);
            window.console.log(response.status);
            if (response.status === 200) {
                // send to other users the result
                this.$emit("sendAction", {
                    id: this.photo.actionId,
                    type: "photo",
                    title: this.title,
                    state: 1,
                    user: this.selectedUser,
                    answer: {
                        photoId: response.data,
                        fileName: this.photo.filename,
                    },
                });
                this.$emit("close");
            } else {
                // Show error
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.camera-container {
    padding: 20px;
    display: inline-block;
    width: 100%;
    text-align: center;
}
</style>